import { APP_PROMOTION_ASSETS, APP_PROMOTION_LINKS, APP_PROMOTION_SIZES } from '@app/consts';
import { AppPromotionPlatform } from '@app/models';

interface BaseLinkConfig {
    href: string;
    alt: string;
    desktopSrc: string;
    mobileSrc: string;
    desktopSize: { htmlWidth: number; htmlHeight: number };
    mobileSize: { htmlWidth: number; htmlHeight: number };
}
const {
    buttons: { googlePlay: googlePlaySizes, appStore: appStoreSizes },
} = APP_PROMOTION_SIZES;

const BASE_LINK_CONFIG: Record<AppPromotionPlatform, BaseLinkConfig> = {
    [AppPromotionPlatform.GooglePlay]: {
        href: APP_PROMOTION_LINKS.googlePlayUrl,
        alt: 'Google Play',
        desktopSrc: APP_PROMOTION_ASSETS.googlePlay,
        mobileSrc: APP_PROMOTION_ASSETS.googlePlayMobile,
        desktopSize: googlePlaySizes.desktop,
        mobileSize: googlePlaySizes.mobile,
    },
    [AppPromotionPlatform.AppStore]: {
        href: APP_PROMOTION_LINKS.appStoreUrl,
        alt: 'App Store',
        desktopSrc: APP_PROMOTION_ASSETS.appStore,
        mobileSrc: APP_PROMOTION_ASSETS.appStoreMobile,
        desktopSize: appStoreSizes.desktop,
        mobileSize: appStoreSizes.mobile,
    },
};

export const getAppPromotionLinkProps = (platform: AppPromotionPlatform, isMobile: boolean) => {
    const { href, alt, desktopSrc, mobileSrc, desktopSize, mobileSize } =
        BASE_LINK_CONFIG[platform];

    const imageProps = isMobile
        ? { src: mobileSrc, ...mobileSize }
        : { src: desktopSrc, ...desktopSize };

    return {
        href,
        alt,
        ...imageProps,
    };
};
